var _defs, _rect, _text, _switch;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "91px",
    height: "51px",
    viewBox: "-0.5 -0.5 91 51",
    content: "<mxfile host=\"Electron\" modified=\"2022-08-17T07:58:41.956Z\" agent=\"5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/16.5.1 Chrome/96.0.4664.110 Electron/16.0.7 Safari/537.36\" etag=\"xX5zPmv37bwIQZQhGleD\" version=\"16.5.1\" type=\"device\"><diagram id=\"Wjv8QnfVCvg292UuV0WK\" name=\"Page-1\">jZNRb4IwEMc/DY8mQIfK40DdkmVx0SVL9tbRCo2lR0oR8NOvyCEyY7Iner/e/e96dzgkzpsXTYvsHRiXju+yxiErx/e9wA/tpyNtT2Ze+DTvUaoFQ7cR7MWZI3SRVoLxcuJoAKQRxRQmoBRPzIRRraGeuh1ATrMWNOV3YJ9QeU+/BDNZT5f+YuSvXKTZkNmb45NzOjjjS8qMMqhvEFk7JNYApj/lTcxl176hL33c5sHttTDNlflPwM+ueluw5bffHpfJbltv1qftDFVOVFb44I91hPWadmiC4Y1NEVEpUmVJYjNybcGJayNsr57xIheMdTGR5qU4059LvGvtAoQyl0kEkROsOq3KQNlP27NmaTQceQwSrO5KgepUDkLKvwiU2dBcyG6hPmkGOUW6x3K9we7FyQLtQcjxieuSRUC6rAVNhEqxyMzkEgWwK/Z5vHnYbu86RLv/HHJudGtdMGBGwqCPwd0nboibUI+LNKDsZocCZBRXN71qj9O1BxzwYI6LdLm7+SHJ+hc=</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 90,
    height: 50,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 25,
      marginLeft: 45
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #003753; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 37,
      fontFamily: "Tahoma",
      color: "rgb(0, 55, 83)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "nowrap"
    }
  }, "PEB")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 36,
    fill: "#003753",
    fontFamily: "Tahoma",
    fontSize: "37px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "PEB"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeb);
export default __webpack_public_path__ + "static/media/peb.9a44ce8713c83852766d5b6dfffaff8c.svg";
export { ForwardRef as ReactComponent };